<template lang='pug'>
v-app#app
  theme-provider
  section.flex.w-full.h-screen.opacity-80.relative.items-center.justify-center(
    :style="`background-color: #303639; background-image: url(${'../static/hero-wallpaper.jpg'}); background-repeat: no-repat; background-size: cover; background-blend-mode: multiply;  `"
  )
    .footer-copy(v-if="!isMovil")
      small  © Copyright {{new Date().getFullYear()}} - Todos los derechos reservados {{empresaFull}}
    .d-flex.ai-center.jc-center.header-logo(v-if="!isMovil")
      v-img(src='/static/logo.png', max-width='150', contain)
    .d-flex.fd-column.jc-center.ai-center.h-full.w-full
      .d-flex.flex-col.ai-center.mb-2
        h1.font-black.white--text(:class="isMovil ? 'font-size-45' : 'font-size-40'") Help Desk
        //- small.white--text Sistema de gestion de tickets para empresas o personas naturales
      v-card.elevation-8.pa-3.card-principal( :width="isMovil ? '100%' : 400" )
        v-tabs(color='primary' dense  centered, v-if='!hideTabs')
          v-tab(to='/') Iniciar Sesión
          v-tab(to='/register') Registrarse
        v-tabs-items(dense)
          router-view
    notifications(position="top right", :class="isMovil ? 'width-full' : ''")
      template(slot='body' slot-scope='props')
        v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border='left' :type='props.item.type')
          small.font-size-12 {{props.item.text}}
  loading-transaction(v-if='transaction.isProceso' :label='transaction.message')
</template>
<script>
import loadingTransaction from '@/components/c_loading_transaction';
import themeProvider from '@/components/c_theme_changer';
export default {
  components: {
    'loading-transaction': loadingTransaction,
    'theme-provider': themeProvider
  },
  data: () => ({
    hideTabs: false,
    empresaFull: process.env.EMPRESA_FULL
  }),
  computed: {
    isMovil () {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    transaction () {
      var vm = this;
      return vm.$store.state.app.transaction;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to) {
        var vm = this;
        vm.hideTabs =
          to.name === 'forgot-password' ||
          to.name === 'profile-activate' ||
          to.name === 'forgot-password-post';
      }
    }
  },
  methods: {}
};
</script>
<style lang='stylus'>
@import '~animate.css';
@import './assets/css/main.styl'
.footer-copy
  position: absolute;
  bottom: 10px;
  z-index: 1;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  opacity: 0.50;
.h-full
  height 100%
.header-logo
  position: absolute;
  top: 19px;
  left: 21px;
  z-index: 100;
  filter: brightness(0) invert(1) drop-shadow(2px 4px 6px black)
.card-principal
  // border-radius 15px !important
.font-size-35
  font-size 35px
</style>



// WEBPACK FOOTER //
// Not_Logged_App.vue?565248be